<template>
  <div>
    <v-textarea
      v-if="groupAddress1 === undefined && companyAddress != ''"
      name="companyAddress"
      label="Company address"
      :value="companyAddress"
      placeholder=" "
      @input="$emit('update:companyAddress', $event)"
      auto-grow
      ></v-textarea>
    <v-text-field
      name="groupAddress1"
      label="Address 1"
      :value="groupAddress1"
      placeholder=" "
      @input="$emit('update:groupAddress1', $event)"
      ></v-text-field>
    <v-text-field
      name="groupAddress2"
      label="Address 2"
      :value="groupAddress2"
      placeholder=" "
      @input="$emit('update:groupAddress2', $event)"
      ></v-text-field>
    <v-text-field
      name="groupCityRegion"
      label="City/Region"
      :value="groupCityRegion"
      placeholder=" "
      @input="$emit('update:groupCityRegion', $event)"
      ></v-text-field>
    <v-text-field
      name="groupCountyState"
      label="County/State"
      :value="groupCountyState"
      placeholder=" "
      @input="$emit('update:groupCountyState', $event)"
      ></v-text-field>
    <v-text-field
      name="groupPostcode"
      label="Postcode/Zipcode"
      :value="groupPostcode"
      placeholder=" "
      @input="$emit('update:groupPostcode', $event)"
      ></v-text-field>
    <v-text-field
      name="groupCountry"
      label="Country"
      :value="groupCountry"
      placeholder=" "
      @input="$emit('update:groupCountry', $event)"
      ></v-text-field>
  </div>
</template>

<script>
export default {
  name: 'AddressFields',
  props: [
    'companyAddress',
    'groupAddress1',
    'groupAddress2',
    'groupCityRegion',
    'groupCountyState',
    'groupPostcode',
    'groupCountry'
  ]
}
</script>
